import { ApiUrls } from 'shared/config/model/urls';

import { createApi } from '@reduxjs/toolkit/query/react';
import { AxiosRequestHeaders } from 'axios';

import { IIncidentTypeStats } from 'features/admin/model/IIncidentTypeStats';

import httpBaseQuery from '../../../shared/api/rtk-query/httpBaseQuery';

export const incidentStatsAPI = createApi({
    reducerPath: 'incidentStatsAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['IncidentStats'],
    refetchOnMountOrArgChange: 60,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (build) => ({
        getIncidentTypeStats: build.query<IIncidentTypeStats[], void>({
            query: () => ({
                path: ApiUrls.INCIDENTS_TYPE_STATS,
                headers: {
                    Accept: 'application/json',
                } as unknown as AxiosRequestHeaders,
            }),
            providesTags: ['IncidentStats'],
            transformResponse: (response: IIncidentTypeStats[]) => {
                return [...response].sort((a, b) =>
                    new Date(a.date).getTime() - new Date(b.date).getTime(),
                );
            },
        }),
    }),
});

export const {
    useGetIncidentTypeStatsQuery,
} = incidentStatsAPI;
